import type {
	HotelApplicationDataQueryQuery,
	TicketListAvailable_BillingPageQuery,
} from "@/lib/gql/__generated__/graphql";

import { FeatureIslandContainer } from "@/components/features/_layouts";

import { useSettingsPaymentCreditDialog } from "../../../payment-credit/ui/dialog/dialog";
import * as UseCase from "../../model/use-case";
import { SettingsBillingHeader, SettingsBillingMain } from "../_components";

import type { ServerModel } from "../../../payment-credit/repository";

type Props = {
	hotelID: string;
	paymentCreditServerModel: ServerModel;
	hotelApplicationData: HotelApplicationDataQueryQuery;
	availableTicketList: TicketListAvailable_BillingPageQuery;
};

export const SettingsBillingPresenter = ({
	hotelID,
	paymentCreditServerModel,
	hotelApplicationData,
	availableTicketList,
}: Props) => {
	const { SettingsPaymentCreditDialog, activateCreditCardSettingDialog } = useSettingsPaymentCreditDialog({
		hotelID,
		serverModel: paymentCreditServerModel,
	});

	const {
		ticketBasicListAvailable,
		ticketProListAvailableContinuousBilling,
		ticketProListAvailableSingleBilling,

		isUsingPro,

		openBillingSettingDialog,
		handleOpenChange,
		activateBillingSettingDialog,
		deactivateBillingSettingDialog,

		billingStatus,
		onPurchaseBasicBillingTicket,
		onPurchaseProBillingTicket,
		onRecurringPurchaseProBillingTicket,

		navigateToCancellationPage,
	} = UseCase.useInitialized({
		hotelID,
		activateCreditCardSettingDialog,
		hotelApplicationData,
		availableTicketList,
	});

	if (!billingStatus) return null;

	return (
		<FeatureIslandContainer>
			<SettingsBillingHeader />
			<SettingsBillingMain
				hotelID={hotelID}
				ticketBasicListAvailable={ticketBasicListAvailable}
				ticketProListAvailableContinuousBilling={ticketProListAvailableContinuousBilling}
				ticketProListAvailableSingleBilling={ticketProListAvailableSingleBilling}
				isUsingPro={isUsingPro}
				billingStatus={billingStatus}
				onPurchaseBasicBillingTicket={onPurchaseBasicBillingTicket}
				onPurchaseProBillingTicket={onPurchaseProBillingTicket}
				onRecurringPurchaseProBillingTicket={onRecurringPurchaseProBillingTicket}
				activateBillingSettingDialog={activateBillingSettingDialog}
				deactivateBillingSettingDialog={deactivateBillingSettingDialog}
				openBillingSettingDialog={openBillingSettingDialog}
				handleOpenChange={handleOpenChange}
				navigateToCancellationPage={navigateToCancellationPage}
			/>

			{SettingsPaymentCreditDialog}
		</FeatureIslandContainer>
	);
};

SettingsBillingPresenter.displayName = "SettingsBillingPresenter";
